import {NgModule} from '@angular/core';
import {SafeUrlPipe} from "./safe-html.pipe";
import {ArrayLastElementPipe} from "./arrayLastElement.pipe";
import {VencimientoDiasPipe} from "./vencimiento-dias.pipe";
import {IsoToFormatPipe} from "./iso-to-format.pipe";
import {PrintArrayPipe} from "./PrintArrayPipe";
import {PluckPipe} from "./PluckPipe";
import { CuitMaskPipe } from '../util/cuit-mask-directive';

@NgModule({
  declarations: [
    SafeUrlPipe,
    ArrayLastElementPipe,
    VencimientoDiasPipe,
    IsoToFormatPipe,
    PrintArrayPipe,
    PluckPipe,
    CuitMaskPipe
  ],
  exports: [
    SafeUrlPipe,
    ArrayLastElementPipe,
    VencimientoDiasPipe,
    IsoToFormatPipe,
    PrintArrayPipe,
    PluckPipe,
    CuitMaskPipe
  ],
  imports: [
  ]
})
export class CustomPipesModule { }
